var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6727 0.908379C11.8242 0.842507 11.9901 0.819788 12.153 0.842587C12.3159 0.865385 12.4699 0.932869 12.599 1.03801C12.7281 1.14316 12.8275 1.28212 12.887 1.44043C12.9465 1.59875 12.9637 1.77063 12.9371 1.93818L11.5464 10.651C11.4115 11.4914 10.5187 11.9734 9.77241 11.5547C9.14819 11.2045 8.22106 10.6649 7.38713 10.1019C6.97016 9.82003 5.6929 8.91753 5.84987 8.27533C5.98477 7.72623 8.13092 5.66282 9.35728 4.43605C9.83863 3.95409 9.61912 3.67605 9.05069 4.11939C7.63914 5.22012 5.37282 6.89402 4.6235 7.36523C3.96249 7.78069 3.61788 7.85163 3.20582 7.78069C2.45406 7.65149 1.75687 7.45136 1.18783 7.20753C0.418901 6.87819 0.456306 5.78632 1.18722 5.46839L11.6727 0.908379Z",
    fill: "#533884"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.c1d67300a78047c6108e301fd1605d41.svg";
export { ForwardRef as ReactComponent };